__turbopack_context__.v({
  "button": "BiggerNeeds-module-scss-module__jZwy1G__button",
  "description": "BiggerNeeds-module-scss-module__jZwy1G__description",
  "section": "BiggerNeeds-module-scss-module__jZwy1G__section",
  "title": "BiggerNeeds-module-scss-module__jZwy1G__title",
});
